<ng-template #modalTemplate>
  <button
    type="button"
    class="info-modal-close"
    aria-label="Close"
    (click)="modalRef.close()"
  >
    <svg-icon
      class="icon-close"
      [src]="'../../../assets/images/icons/close.svg'"
    ></svg-icon>
  </button>
  <div class="qr-container">
    <h4>{{ prefix + ".recommendations" | msg | async }}</h4>
    <div class="qr-grid">
      <div class="grid-item"></div>
      <div class="grid-item align-bottom">
        <img
          src="../../../assets/images/icons/appstore.png"
          alt="appstore"
          width="80"
          height="80"
        />
      </div>
      <div class="grid-item align-bottom">
        <img
          src="../../../assets/images/icons/playstore.png"
          alt="appstore"
          width="80"
          height="80"
        />
      </div>
      <div class="grid-item">
        <img
          src="../../../assets/images/icons/microsoft.png"
          alt="appstore"
          width="80"
          height="80"
        />
      </div>
      <div class="grid-item">
        <qrcode [width]="145" [qrdata]="qrMicrosoftApple"></qrcode>
      </div>
      <div class="grid-item">
        <qrcode [width]="145" [qrdata]="qrMicrosoftAndroid"></qrcode>
      </div>
      <div class="grid-item">
        <img
          src="../../../assets/images/icons/googleauth.png"
          alt="appstore"
          width="80"
          height="80"
        />
      </div>
      <div class="grid-item">
        <qrcode [width]="145" [qrdata]="qrGoogleApple"></qrcode>
      </div>
      <div class="grid-item">
        <qrcode [width]="145" [qrdata]="qrGoogleAndroid"></qrcode>
      </div>
    </div>
  </div>
</ng-template>
